import { put } from './BaseApi';

export async function insertStudentInsurances(pid: string, data: {
  studentId: string,
  insurance: number,
  states: string
}[]): Promise<void> {
  await put(`/api/insurance/student/insert/${pid}`, data)
}